import { GetVenueOverviewVersionType as ApiGetVenueOverviewVersionType } from 'src/api/generated/touring/types';
import {
  mapBusinessSeatsType,
  mapFoodBeverageContactType,
  mapInhouseTicketSystemType,
  mapMerchType,
  mapSuitesType,
  mapVenueSurchargesType,
} from './helpers';
import { VenueOverviewVersionType } from './types';

export const mapVenueOverviewVersionType = (
  apiType: ApiGetVenueOverviewVersionType
): VenueOverviewVersionType => {
  return {
    suites: mapSuitesType(apiType.suites),
    businessSeats: mapBusinessSeatsType(apiType.businessSeats),
    venueSurcharges: mapVenueSurchargesType(apiType.venueSurcharges),
    venueComps: apiType.venueComps,
    inhouseTicketSystem: mapInhouseTicketSystemType(
      apiType.inhouseTicketSystem
    ),
    merch: mapMerchType(apiType.merch),
    foodBeverageContact: mapFoodBeverageContactType(
      apiType.foodBeverageContact
    ),
  };
};

